'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rafDebounce = require('raf-debounce');

var _rafDebounce2 = _interopRequireDefault(_rafDebounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (domElement, callback) {
  var debounce = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (global.MutationObserver == null && global.ResizeObserver == null) {
    return function () {};
  }

  var debouncedCallback = (0, _rafDebounce2.default)(callback).fn;

  if (global.ResizeObserver == null) {
    var recordedSize = {};

    var onChange = function onChange() {
      var boundingClientRect = domElement.getBoundingClientRect();

      if (boundingClientRect.width !== recordedSize.width || boundingClientRect.height !== recordedSize.height || boundingClientRect.top !== recordedSize.top || boundingClientRect.left !== recordedSize.left || boundingClientRect.right !== recordedSize.right || boundingClientRect.bottom !== recordedSize.bottom || boundingClientRect.x !== recordedSize.x || boundingClientRect.y !== recordedSize.y) {
        recordedSize = boundingClientRect;
        debounce ? debouncedCallback(recordedSize) : callback(recordedSize);
      }
    };

    var _observer = new global.MutationObserver(onChange);

    global.addEventListener('resize', onChange);

    _observer.observe(domElement, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true
    });

    debounce ? debouncedCallback(domElement.getBoundingClientRect()) : callback(domElement.getBoundingClientRect());

    return function () {
      _observer.disconnect();
      global.removeEventListener('resize', onChange);
    };
  }

  var observer = new global.ResizeObserver(function () {
    return debounce ? debouncedCallback(domElement.getBoundingClientRect()) : callback(domElement.getBoundingClientRect());
  });

  observer.observe(domElement);

  return function () {
    return observer.disconnect();
  };
};